import template from './holidays_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class HolidaysHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class HolidaysHelpPage
{
	constructor (bindings) {
		this.viewModel = new HolidaysHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'HolidaysHelp',
	dialog_class: HolidaysHelpPage,
	template: template,
	template_filename: 'translation/dialogs/holidays_help',
	provider: 'ps'
};
